<template>
    <div v-if="!needToProcessLogin">
        <v-menu>      
            <v-toolbar-title slot="activator" class="profile">
                <span class="name hidden-sm-and-down">
                {{ name }}       
                </span> 
                <v-btn icon>
                    <v-icon>person</v-icon>
                </v-btn>        
            </v-toolbar-title>
            <v-list>
                <v-list-tile @click="signOut()">
                    <v-list-tile-title>Sign Out</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>    
    </div>   
</template>

<script>
import auth from "../../services/auth"

export default {
    name: 'profile',
    computed: {
        needToProcessLogin: function () {
            return auth.needToProcessLogin();
        },
        name: function () {
            return this.$store.getters["authStore/getUserProfileName"];
        },
    },
    methods: {
        signOut () {
            this.$router.push({
                path: "/logout"
            });
        }
    }
}
</script>

<style scoped>
.name {
    font-size: 11pt;
}
</style>